/** Clé localStorage : hub sélecteur vs pratique (partagée App / hub / invité). */
export const ADAPTIVE_EXAM_ENTRY_KEY = 'adaptive_exam_entry';
